import React from "react";

const NotFound = () => {
  return (
    <div>
      <center>
        <h1>Error 404! Page Not Found</h1>
      </center>
    </div>
  );
};

export default NotFound;
